// the 404 page - what you get when a url doesn't match any route
import React from 'react';
// Link navigates between our pages without reloading the whole browser
import { Link } from 'react-router-dom';
// borrows the legal pages' stylesheet - same centered column and nav, no need
// for a second copy of it just for this
import './LegalPage.css';
import { usePageMeta } from '../hooks/usePageMeta';

export default function NotFoundPage() {
  usePageMeta({
    title: 'Page not found - GPTDisguise',
    description: 'That page does not exist. Head back to the GPTDisguise homepage.',
    path: '/404',
    // a missing page has nothing worth putting in search results, and letting
    // google index it would just fill the site with near-identical entries
    noIndex: true
  });

  return (
    <div className="legal-page">
      {/* NAV - same logo + back link as the legal pages */}
      <nav className="legal-nav">
        <a href="/" className="legal-nav-logo">
          <img src="/icon.png" alt="GPTDisguise icon" className="legal-nav-icon" />
          GPT<span>Disguise</span>
        </a>
        <Link to="/" className="legal-nav-back">← Back to home</Link>
      </nav>

      <main className="legal-content">
        <p className="legal-eyebrow">404</p>
        <h1>Page not found</h1>
        <p className="legal-lead">
          The page you're after doesn't exist, or it may have moved. Check the
          address, or start again from the homepage.
        </p>
        <p>
          <Link to="/">Go to the homepage</Link> · <Link to="/signin">Sign in</Link>
        </p>
      </main>
    </div>
  );
}
